import React from 'react';
import clsx from 'clsx';

import Icon from '../../../icons/Icon';

import scss from './MobileNavigation.module.scss';

function NavigationItem({ label, icon, url, pathname, isStrokeIcon, selectedRoutes = [], disabled, onNavigate }) {
  const handleNavigate = () => {
    onNavigate(url);
  };

  return (
    <span
      className={clsx(
        scss.navLink,
        disabled && scss.navLinkDisabled,
        (pathname === url || selectedRoutes.includes(pathname)) && scss.navLinkActive,
      )}
      onClick={handleNavigate}
      role='presentation'>
      <span className={scss.iconWrapper}>
        <Icon icon={icon} size={18} className={clsx(scss.icon, isStrokeIcon && scss.iconStroke)} disableCommonColors />
      </span>
      <span className={scss.label}>{label}</span>
    </span>
  );
}

export default NavigationItem;
